export default {
  requireAuth (to, from, next) {
    if (to.name !== 'login' && !window.localStorage.getItem('token')) {
      next({
        name: 'login'
      })
    } else {
      next()
    }
  },
  checkLogged (to, from, next) {
    if (to.name === 'login' && window.localStorage.getItem('token')) {
      next('/dashboard')
    } else {
      next()
    }
  },
  getUser () {
    return JSON.parse(window.localStorage.getItem('user'))
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js